/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './clinical-dictionary-type.reducer';

export const ClinicalDictionaryTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaryTypeEntity = useAppSelector(state => state.clinicalDictionaryType.entity);
  const loading = useAppSelector(state => state.clinicalDictionaryType.loading);
  const updating = useAppSelector(state => state.clinicalDictionaryType.updating);
  const updateSuccess = useAppSelector(state => state.clinicalDictionaryType.updateSuccess);

  const handleClose = () => {
    navigate(`/clinical-dictionary-type${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createDate !== undefined && typeof values.createDate !== 'number') {
      values.createDate = Number(values.createDate);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...clinicalDictionaryTypeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...clinicalDictionaryTypeEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.clinicalDictionaryType.home.createOrEditLabel" data-cy="ClinicalDictionaryTypeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.home.createOrEditLabel">
              Create or edit a ClinicalDictionaryType
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="clinical-dictionary-type-id"
                  label={translate('tinyMedicRestApp.clinicalDictionaryType.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.entryId')}
                id="clinical-dictionary-type-entryId"
                name="entryId"
                data-cy="entryId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="entryIdLabel">
                <Translate contentKey="tinyMedicRestApp.clinicalDictionaryType.help.entryId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.dictType')}
                id="clinical-dictionary-type-dictType"
                name="dictType"
                data-cy="dictType"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.especiality')}
                id="clinical-dictionary-type-especiality"
                name="especiality"
                data-cy="especiality"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.dictDescription')}
                id="clinical-dictionary-type-dictDescription"
                name="dictDescription"
                data-cy="dictDescription"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.createdBy')}
                id="clinical-dictionary-type-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.createDate')}
                id="clinical-dictionary-type-createDate"
                name="createDate"
                data-cy="createDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.lastUpdated')}
                id="clinical-dictionary-type-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.lastModifiedBy')}
                id="clinical-dictionary-type-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.active')}
                id="clinical-dictionary-type-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.cursor')}
                id="clinical-dictionary-type-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.microSec')}
                id="clinical-dictionary-type-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.clinicalDictionaryType.timestampEntry')}
                id="clinical-dictionary-type-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/clinical-dictionary-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ClinicalDictionaryTypeUpdate;
